export default Object.freeze({
  REGISTERED: 'REGISTERED',
  VALIDATED: 'VALIDATED',
  NOT_VALIDATED: 'NOT_VALIDATED',
  ONBOARDING: 'ONBOARDING',
  ASSISTED_OPERATIONAL: 'ASSISTED_OPERATIONAL',
  OPERATIONAL: 'OPERATIONAL',
  REJECTED: 'REJECTED',
})
